// composables/useDialog.ts
import { createVNode, render } from 'vue';
import Dialog from '/@/components/Dialog/src/Dialog.vue';
import { useDialogStoreWithOut } from '/@/store/modules/dialog';

export function useDialog() {
  const dialogStore = useDialogStoreWithOut();

  return {
    confirm({
      title = '',
      content,
      onConfirm,
      duration = 0,
      showFooter = false,
    }: {
      title?: string;
      content: string;
      duration?: number; // in milliseconds, 0 means no auto-close
      onConfirm: () => void;
      showFooter?: boolean;
    }) {
      const container = document.createElement('div');
      document.body.appendChild(container);

      const vnode = createVNode(Dialog, {
        title,
        content,
        showFooter,
        onConfirm: () => {
          onConfirm();
          close();
        },
        onCancel: close,
      });
      if (duration !== 0) {
        setTimeout(() => {
          close();
        }, duration);
      }

      function close() {
        dialogStore.closeDialog();
        render(null, container);
        document.body.removeChild(container);
      }
      dialogStore.openDialog();
      render(vnode, container);
    },
  };
}
